/* eslint-disable import/prefer-default-export */
export const COUPON_STATUS_FILTERS = {
  AVAILABLE: 'available',
  CLIPPED: 'clipped',
  REDEEMED: 'redeemed',
};
